import { ReactElement, ReactNode, useMemo } from 'react'
import { FieldErrorsImpl, useFormContext } from 'react-hook-form'
import isUndefined from 'lodash-es/isUndefined'
import { Stack } from '@mui/system'
import { ErrorFieldBase } from '..'

interface Props {
  basePath?: string
}

/**
 * Render all errors of a form component. Uses form context to get all errors of
 * the form
 */
const Errors = ({ basePath }: Props): ReactElement => {
  const {
    formState: { errors },
  } = useFormContext()

  const errorsOfBasePath = useMemo(() => {
    if (basePath && errors) {
      if (basePath in errors) {
        return errors[basePath]
      } else {
        return undefined
      }
    } else {
      return errors
    }
  }, [basePath, errors]) as Partial<
    FieldErrorsImpl<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [x: string]: any
    }>
  >

  const renderErrors = (
    errors: Partial<
      FieldErrorsImpl<{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [x: string]: any
      }>
    >,
  ): ReactNode[] =>
    Object.values(errors).map(error => {
      if (!isUndefined(error?.message)) {
        return (
          <ErrorFieldBase
            key={error?.message as string}
            message={error?.message as string}
            severity="error"
          />
        )
        // @ts-ignore
      } else return renderErrors(error)
    })

  return (
    <Stack direction="column" spacing={1}>
      {errorsOfBasePath && renderErrors(errorsOfBasePath)}
    </Stack>
  )
}

export default Errors
